import React, { useState } from 'react'
import './ContectUsForm.css'
import { postData } from '../../../Api/Clientfunctions';
import { AiOutlineSkype } from "react-icons/ai";


const ContectUsForm = () => {

    const [formData, setFormData] = useState({
        name: '',
        email: '',
        message: "",
        phone: "",
    });


    const handleInputChange = (e) => {
        const { name, value, email, country, phone, message } = e.target;
        setFormData({
            ...formData,
            [name]: value,
            [email]: value,
            [phone]: value,
            [message]: value
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        formData.type = 0;
        console.log("Form data:", formData);
        const res = await postData("/contact/submit-enquiry", formData)
        console.log(res)
    };


    return (
        <>
            <section className="section-bg" style={{ marginTop: '40px', paddingTop: '30px' }} >
                <div className="overlay-1 pt-100 pb-100 ">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-6 d-flex align-items-center pb-5">
                                <div className="contact-info"> 
                                    <h2 className="contact-title">Have Any Questions?</h2>
                                    <p> It encourages visitors to reach out for assistance, inquiries, or feedback, facilitating better communication and engagement between the business and its audience.</p>
                                    <ul className="contact-info">
                                        <a href="tel: +91 9358 593 003" target="_blank" rel="noopener noreferrer">
                                            <li>
                                                <div className="info-left">
                                                    <i className="fas fa-mobile-alt" />
                                                </div>
                                                <div className="info-right">
                                                    <h4>+91 935 859 3003</h4>
                                                </div>
                                            </li>
                                        </a>
                                        <a href="mailto:info@metablocktechnologies.in" target="_blank" rel="noopener noreferrer">
                                            <li>
                                                <div className="info-left">
                                                    <i className="fas fa-envelope"></i>
                                                </div>
                                                <div className="info-right">
                                                    <h4>info@metablocktechnologies.in</h4>
                                                </div>
                                            </li>
                                        </a>
                                        <li>
                                            <div className="info-left">
                                                <i className="fas fa-map-marker-alt" />
                                            </div>
                                            <div className="info-right">
                                                <h4>30-A, Gopalpura Bypass Rd, opp. Holiday Inn Hotel, opp. Holiday Inn, Sultan Nagar, Santi Nagar, Gurjar Ki Thadi, Jaipur, Rajasthan 302020</h4>
                                            </div>
                                        </li>
                                        <div className="social-iconss" style={{ display: 'flex', alignItems: 'center', justifyContent: 'start', gap: '10px' }}>
                                            <a href="https://twitter.com/metablocktech" target="_blank" rel="noopener noreferrer"><i className="fab fa-twitter" style={{ color: '#1DA1F2' }} /></a>
                                            <a href="https://www.facebook.com/Metablocktechnologies"
                                                target="_blank" rel="noopener noreferrer"><i className="fab fa-facebook-f" style={{ color: '#3b5998' }} /></a>
                                            <a href="https://www.instagram.com/metablocktechnologies1?igsh=Zmxva3Fnd3o1NzBw" target="_blank" rel="noopener noreferrer"><i className="fab fa-instagram" style={{ color: '#C13584' }} /></a>
                                            <a href="https://www.linkedin.com/company/metablocktechnologies" target="_blank" rel="noopener noreferrer"><i className="fab fa-linkedin-in" style={{ color: '#0077B5' }} /></a>
                                            <a href="skype:your_skype_username?chat" target="_blank" rel="noopener noreferrer"><i className="fab fa-skype" style={{ color: '#00aff0' }} /></a>
                                        </div>
                                    </ul>
                                </div>
                            </div>
                            <div className="col-lg-6 d-flex align-items-center">
                                <div className="relative pb-[56.25%] h-[450px] w-full overflow-hidden rounded-lg">
                                    <iframe
                                        className="absolute top-0 left-0 w-full h-full"
                                        src="https://metablock-software.metablocktechnologies.org/forms/wtl/fd876e62bfe1d7911b0e2be0ddb895fb"
                                        frameborder="0"
                                        sandbox="allow-top-navigation allow-forms allow-scripts allow-same-origin allow-popups"
                                        allowfullscreen
                                    ></iframe>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>

        </>
    )
}

export default ContectUsForm
